module.exports = __webpack_public_path__ + "img/anyRead_detail.bc3e2cd8.png";